import PropTypes from 'prop-types'
import React from 'react'
import styles from './_sidebarWidget.css'

export default function SidebarWidget ({ children }) {
  return (
    <div className={styles.sidebarContainer}>
      {children}
    </div>
  )
}

SidebarWidget.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarWidget.jsx